
export const VocabProOnboarding = {
    //  Title
    'pro_onboarding_title': ['Nos alegra tenerte', 'We are glad to have you'],
    'pro_onboarding_message': ['Súmate a la red de profesionistas y juntos llevemos tu practica al siguiente nivel.', 
        "Join the network of professionals and together let's take your practice to the next level."],
    'confidentiality_legend': ['Toda la informacion recabada es confidencial y esta protegida de acuerdo con nuestras', 
        'All gathered data is confidential and is protected under our'],
    'confidentiality_link': ['politicas de privacidad', 'privacy policies'],
    /*  Step 0 Welcome instructions   */
    'welcome_title': ["Creemos tu perfil profesional!", "Let's create your professional profile!"],
    'welcome_intro': ['Este formulario nos ayudara a cubrir los basicos de tu practica.', 
        'This will help us cover the basics of your practice.'],
    'time_label': ["Tiempo estimado:", "Estimated time:"],
    'time_value': ["10 - 15 minutos", "10 - 15 minutes"],
    'prep_title': ["Necesitarás tener a la mano:", "You'll need to have handy:"],
    'professional_id':["Cédula profesional", "professional ID"], 
    'contact_number':["Numero de contacto", "Contact number"],
    'office_hours':["Horario de trabajo", "Office hours"],
    'office_address': ["Dirección de la oficina", "Office address"],

    'resume': ["Puedes guardar tu progreso y continuar después si lo necesitas.", 
        "You can save your progress and continue later if needed."],
    /*  Step 1 Basics   */
    'basics_title': ['Informacion basica', 'Basic information'],
    'biological_sex': ['Sexo biologico', 'Biological sex'],
    'current_sex': ['Sexo actual', 'Current sex'],
    'birthday': ['Fecha de nacimiento', 'Birth date'],
    'blood_type': ['Tipo de sangre', 'Blood type'],
    'religion': ['Religión', 'Religion'],
    'occupation': ['Ocupación', 'Occupation'],
    'birthplace': ['Lugar de nacimiento', 'Birthplace'],
    'male': ['Hombre', 'Male'],
    'female': ['Mujer', 'Female'],
    'height': ['Altura (cm)', 'Height (cm)'],
    'weight': ['Peso (kg)', 'Weight (kg)'],
    'civil_status': ['Estado civil', 'Civil status'],
    'education': ['Escolaridad', 'Education'],
    'elementary': ['Primaria', 'Primary'],
    'secondary': ['Secundary', 'Secondary'],
    'high_school': ['Preparatoria', 'High school'],
    'professional': ['Profesional', 'Professional'],
    'master': ['Maestria', 'Maestria'],
    'doctorate': ['Doctorado', 'Doctorate'],

    /*  Step 2 Qualifications */
    'academic_history': ['Historia academica', 'Academic_history'],
    'education_title': ['Título', 'Title'],
    'education_title_placeholder': ['ej. Médico Cirujano', 'e.g. Medical Surgeon'],
    'institution': ['Institución', 'Institution'],
    'institution_placeholder': ['ej. UNAM', 'e.g. UNAM'],
    'category': ['Categoría', 'Category'],
    'year_of_completion': ['Año de finalización', 'Year of completion'],
    'year_must_be_greater': ['El año debe ser > 1940', 'Year must be > 1940'],
    'required_value': ['Requerido', 'Required'],
    'license' : ['Cédula', 'License'],
    'new_qualification': ['Nuevo grado', 'New qualification'],
    'missing_fields': ['Campos faltantes', 'Missing fields'],
    'please_add_qualification': ['Por favor, añade al menos un título profesional.', 'Please add at least one professional title.'],
    //  Personal phone
    'personal_phones': ['Numeros personales', 'Personal Phones'],
    'add_phone': ['Añadir telefono', 'Add number'],
    //  Emergency contacts
    'emergency_contacts': ['Contactos de emergencia', 'Emergency Contacts'],
    'name': ['Nombre', 'Name'],
    'phone': ['Telefono', 'Phone number'],
    'select_relationship': ['Seleccione relacion', 'Select relationship'],
    
    'add_contact': ['Añadir cotnacto', 'Add contact'],
    
    /*  Step 4 Work location   */
    'location_section_title': ['Ubicación de Trabajo', 'Work location'],
    'work_name': ['Nombre del establecimiento', 'Work place name'],
    'work_name_placeholder': ['Ej: Centro Médico Santa Fe', 'Ex: '],
    'interior_number': ['Número Interior', 'Interior Number'],
    'extension': ['Extensión', 'Extension'],
    'street': ['Calle', 'Street'],
    'external_number': ['Numero exterior', 'External number'],
    'state': ['Estado', 'State'],
    'zip_code': ['Codigo postal', 'Zip code'],
    'phone_number': ['Teléfono', 'Phone'],

    '': ['', ''],
  }
